module.exports = __webpack_public_path__ + "img/productImage.2caab87a.png";